import React, { useState, useEffect } from "react";
import axiosClient from "../AxiosClient";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import "../Assets/Css/HomeCss/BannerSearch.css";
import "../Assets/Css/ReactSelect.css";

const BannerSearch = () => {
  const [specialitiesList, setSpecialitiesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [dataForm, setDataForm] = useState({
    city_id: "",
    specialite: [],
  });
  const [errors, setErrors] = useState({
    city_id: "",
    specialite: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch specialties list from new API endpoint
    axiosClient.get("/specializations")
      .then((res) => {
        // Handle different API response formats
        let data = res.data;
        if (!Array.isArray(data)) {
          if (data.specializations && Array.isArray(data.specializations)) {
            data = data.specializations;
          } else if (data.data && Array.isArray(data.data)) {
            data = data.data;
          } else {
            console.error("Unexpected API response format:", data);
            data = [];
          }
        }
        // Transform API response to react-select format
        const formattedData = data.map(item => ({
          value: item.id || item.name || item,
          label: item.name || item
        }));
        setSpecialitiesList(formattedData);
      })
      .catch((err) => {
        console.error("Error fetching specializations:", err);
        setSpecialitiesList([]);
      });
  }, []);

  useEffect(() => {
    // Detect the user's country (ISO2) then load that country's cities
    const detectCountryAndFetchCities = async () => {
      let iso2 = "";

      // Primary: ipwho.is returns { country_code: "PK", ... }
      try {
        const geoRes = await fetch("https://ipwho.is/");
        const geoData = await geoRes.json();
        if (geoData && geoData.success !== false) {
          iso2 = geoData.country_code || "";
        }
      } catch (err) {
        console.error("Error detecting country (ipwho.is):", err);
      }

      // Fallback: geojs.io returns { country: "PK", ... }
      if (!iso2) {
        try {
          const geoRes = await fetch("https://get.geojs.io/v1/ip/country.json");
          const geoData = await geoRes.json();
          iso2 = geoData.country || "";
        } catch (err) {
          console.error("Error detecting country (geojs):", err);
        }
      }

      // Default to Pakistan when the country cannot be detected
      if (!iso2) iso2 = "PK";

      axiosClient.get(`/locations/country-code/${iso2}/cities`)
        .then((res) => {
          if (res.data && res.data.success) {
            const formatted = res.data.data.map((c) => ({
              value: c.id,
              label: c.name,
            }));
            setCitiesList(formatted);
          }
        })
        .catch((err) => {
          console.error("Error fetching cities:", err);
          setCitiesList([]);
        });
    };

    detectCountryAndFetchCities();
  }, []);

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      city_id: "",
      specialite: "",
    };

    if (!dataForm.city_id) {
      newErrors.city_id = "City is required";
      valid = false;
    }

    if (!dataForm.specialite || dataForm.specialite.length === 0) {
      newErrors.specialite = "At least one specialty is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    setDataForm({ ...dataForm, city_id: selectedOption?.value || "" });

    // Clear error when user selects
    if (errors.city_id) {
      setErrors({ ...errors, city_id: "" });
    }
  };

  const handleSpecialiteChange = (selectedOptions) => {
    setDataForm({ ...dataForm, specialite: selectedOptions || [] });
    // Clear error when user selects
    if (errors.specialite) {
      setErrors({ ...errors, specialite: "" });
    }
  };

  const handleSubmitData = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const payload = {
        city_id: dataForm.city_id,
        specialite: (dataForm.specialite || []).map(
          (s) => (s && typeof s === "object" ? s.value : s)
        ),
        gender: "",
        availability: [],
        fee_range: "",
        page: 1,
      };
      navigate("/search-doctor", { state: payload });
    }
  };

  return (
    <section className="banner_search">
      <h2 className="search_heading">Find and Book the <br></br>Best Doctors near you</h2>
      <form onSubmit={handleSubmitData} className="search_form">
        <div className="search_input">
          {/* <label htmlFor="Location" className="label_search">
            Location
          </label> */}
          <Select
            inputId="Location"
            name="city_id"
            options={citiesList}
            value={selectedCity}
            onChange={handleCityChange}
            placeholder="Choose City"
            isClearable
            className={`react-select-container ${errors.city_id ? 'input-error' : ''}`}
            classNamePrefix="react-select"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: '48px',
                borderColor: errors.city_id ? '#ef4444' : base.borderColor,
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
          />
          {errors.city_id && (
            <div className="error-message">
              {errors.city_id}
            </div>
          )}
        </div>

        <div className="search_input">
          {/* <label htmlFor="Specialite" className="label_search">
            Specialty
          </label> */}
          <Select
            inputId="Specialite"
            name="specialite"
            isMulti
            options={specialitiesList}
            value={dataForm.specialite}
            onChange={handleSpecialiteChange}
            placeholder="Select Specialties..."
            className={`react-select-container ${errors.specialite ? 'input-error' : ''}`}
            classNamePrefix="react-select"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: '48px',
                borderColor: errors.specialite ? '#ef4444' : base.borderColor,
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
          />
          {errors.specialite && (
            <div className="error-message">
              {errors.specialite}
            </div>
          )}
        </div>

        <button type="submit" className="btn_search">
          Search
        </button>
      </form>
    </section>
  );
};

export default BannerSearch;
